import { makeStyles, Theme, createStyles, hexToRgb } from '@material-ui/core/styles';
import { TemplateSettings } from '../../store/interfaces';

export const MobileHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      flexShrink: 0,
    },
    mobileDivider: {
      margin: '0.5rem 0',
    },
    icon: ({ utilityBar }) => ({
      width: '26px',
      height: '26px',
      marginBottom: '3px',
      '& path': {
        fill: hexToRgb(utilityBar.textColor),
      },
    }),
    mobileDrawer: (props: TemplateSettings) => ({
      backgroundColor: props.utilityBar.backgroundColor,
      color: props.utilityBar.textColor,
      minHeight: 'calc(100vh - 40px - 165px)',
      marginTop: '40px',
      marginBottom: '165px',
      width: '75%',
      [theme.breakpoints.up('sm')]: {
        minHeight: 'calc(100vh - 40px - 165px)',
      },
      [theme.breakpoints.up('md')]: {
        marginTop: '50px',
        minHeight: 'calc(100vh - 50px - 165px)',
        padding: '2rem',
      },
      '& .language-label-mobile, & .accessibility-label-mobile': {
        textAlign: 'center',
        color: 'inherit',
        marginLeft: '5px',
      },
    }),
    utilityLink: ({ utilityBar }) => ({
      margin: 0,
      padding: 0,
      '& a': {
        color: utilityBar.textColor,
        textDecoration: 'none',
        fontWeight: 'bold',
        '&:visited': {
          textDecoration: 'none',
          color: utilityBar.textColor,
        },
      },
    }),
    menuItem: {
      padding: '0px 20px !important',
    },
    subMenuDropDown: {
      padding: '0px 10px',
    },
    menuItemParent: {
      padding: '0px 15px !important',
    },
    marginBottom20: {
      marginBottom: '20px',
    },
    marginTop20: {
      marginTop: '20px',
    },
    arrowDropDown: {
      width: '18px',
      height: '25px',
      marginLeft: '5px',
    },
    marginBottom25: {
      marginBottom: '25px',
    },
    userProfile: ({ utilityBar }) => ({
      color: utilityBar.textColor,
      cursor: 'pointer',
      fontWeight: 'bold',
      '& svg': {
        fontSize: '1.2rem',
      },
      '& span': {
        marginLeft: '5px',
      },
    }),
    logo: {
      maxWidth: '10rem',
      height: '1.5rem',
    },
  }),
);
